import { useState } from "react";

// Create a company: name + identifier (the tenant key) + optional first
// administrator email (invited by email; they set their own password).
function AddCompanyModal({ onAddClicked, onCancelClicked }) {
  const [name, setName] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    const trimmedName = name.trim();
    const id = identifier.trim().toLowerCase();
    if (!trimmedName) {
      setError("Company name is required");
      return;
    }
    if (!/^[a-z0-9-]{2,40}$/.test(id)) {
      setError("Identifier must be 2-40 lowercase letters, numbers or hyphens");
      return;
    }
    if (adminEmail.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(adminEmail.trim())) {
      setError("Enter a valid administrator email (or leave it blank)");
      return;
    }
    setError("");
    onAddClicked({ name: trimmedName, identifier: id, adminEmail: adminEmail.trim() });
  };

  return (
    <div
      onClick={onCancelClicked}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[448px] bg-white rounded-[6px] p-[18px] flex flex-col"
      >
        <p className="text-[16px] font-OpenSansSemiBold text-titleColor mb-5">ADD COMPANY</p>

        <div className="flex flex-col gap-4">
          <div className="w-full">
            <p className="text-[12px] font-OpenSansSemiBold text-titleColor mb-2">Company Name</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px]">
              <input
                value={name}
                type="text"
                onChange={(e) => setName(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-OpenSansMedium"
                placeholder="Enter company name"
              />
            </div>
          </div>

          <div className="w-full">
            <p className="text-[12px] font-OpenSansSemiBold text-titleColor mb-2">
              Identifier (tenant key — cannot be changed later)
            </p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px]">
              <input
                value={identifier}
                type="text"
                onChange={(e) => setIdentifier(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-OpenSansMedium"
                placeholder="e.g. acme (lowercase, no spaces)"
              />
            </div>
          </div>

          <div className="w-full">
            <p className="text-[12px] font-OpenSansSemiBold text-titleColor mb-2">
              Administrator Email (optional — invited by email)
            </p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px]">
              <input
                value={adminEmail}
                type="email"
                onChange={(e) => setAdminEmail(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-OpenSansMedium"
                placeholder="admin@company.com"
              />
            </div>
          </div>

          {error && <p className="text-[11px] font-OpenSansMedium text-red-500">{error}</p>}

          <div className="w-full mt-2">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={onCancelClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                onClick={submit}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                ADD
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCompanyModal;
